import { Injectable } from '@angular/core';
import { ReportViewerState } from '@mode/reports/sandbox/contract';
import { combineReducers, GenericLegacyRxStoreService } from '@mode/legacy/util-domain';
import { Action, Store, StoreModule } from '@ngrx/store';
import { EmbedViewerRedurcers } from './embed-report.reducers';

// Must match key in ReportViewerState
export const REPORT_VIEWER_FEATURE_KEY = 'reportFeature';

export const EMBED_VIEWER_STORE = [
  StoreModule.forFeature(REPORT_VIEWER_FEATURE_KEY, combineReducers(EmbedViewerRedurcers)),
];

@Injectable({
  providedIn: 'root',
})
export class LegacyEmbedViewerStoreService extends GenericLegacyRxStoreService<ReportViewerState, Action> {
  constructor(store: Store<ReportViewerState>) {
    super(store);
  }
}
